import React, { useEffect, useState } from 'react'
import ListPage from '../../Organisms/ListPage/ListPage'
import 'react-toastify/dist/ReactToastify.css'
import editGreen from './../../../imgs/EditGreen.png'
import deletIcon from './../../../imgs/Group 34774 (1).png'
import { ModalEditObject } from '../CreateStorage/ModalEditObject'
import { CreateNewDataStore } from '../../Organisms/Popups/CreateNewDataStorePopup/CreateNewDataStorePopup'
import { TextInput } from '../../Atoms/Inputs/Text'
import { SelectWithLabelInput } from '../../Atoms/Inputs/SelectWithLabel'
import { useParams } from 'react-router-dom'
import { getDataStorageById, InsertData } from '../../../store/dataStorage/api'
import { getDataModel } from '../../../store/model/api'
import { toast } from 'react-toastify'

export const DataStoreName = () => {
    const [render, setRender] = useState(false)
    const [rows, setRows] = useState([])
    const [selctedRows, setSelectedRows] = useState([])
    const [name, setName] = useState('')
    const [show, setShow] = useState(true)
    const { id } = useParams()

    const [dataStoreColumns, setDataStoreColumns] = useState([])
    const [showPopup, setShowPopup] = useState(false)
    const [isValidJson, setIsValidJson] = useState(true)
    const [objectValue, setObjectValue] = useState('')
    const [rowId, setRowId] = useState('')
    const [key, setKey] = useState('')
    const [n, setN] = useState(1)

    const normalizeColumns = (rows) =>
        rows.map((item, index) => ({ ...item, n: index + 1 }))

    const deleteSelectedRows = () => {
        setRows((prevRows) =>
            normalizeColumns(
                prevRows.filter((row) => !selctedRows.includes(row.n)),
            ),
        )
        setSelectedRows([])
    }

    const deleteSingleRow = (n) => {
        setRows((prevRows) => {
            const updated = prevRows.filter((row) => row.n !== n)
            return normalizeColumns(updated)
        })

        setSelectedRows((prev) => prev.filter((id) => id !== n))
    }

    const editColumn = (id, value, key) => {
        setRows((prev) =>
            prev.map((item) =>
                item.n === id ? { ...item, [key]: value } : item,
            ),
        )
    }

    useEffect(() => {
        getDataStorageById(id)
            .then((response) => {
                setName(response.name)
                setRows(normalizeColumns(response.data))

                const cols = response.modelSchema.map((i) => {
                    let key = i.key
                    return {
                        field: i.key,
                        defaultValue: i.defaultValue,
                        types: i.columnType,
                        minWidth: '300',
                        cellRenderer: (params) => {
                            const n = params.data?.n
                            return (
                                <div style={{ width: '200px', height: '60px' }}>
                                    {i.columnType === 'object' ? (
                                        <textarea
                                            className={`${
                                                isValidJson ? 'initial' : 'red'
                                            }`}
                                            style={{
                                                width: '100%',
                                                height: '52px',
                                            }}
                                            defaultValue={params.data[i?.key]}
                                            onClick={(e) => {
                                                setObjectValue(e.target.value)
                                                setRowId(n)
                                                setKey(key)
                                                setShowPopup(true)
                                            }}
                                        />
                                    ) : i.columnType === 'boolean' ? (
                                        <SelectWithLabelInput
                                            options={['false', 'true']}
                                            defaultValue={String(
                                                params.data[i?.key],
                                            )}
                                            onChange={({ target }) =>
                                                editColumn(
                                                    n,
                                                    JSON.parse(target.value),
                                                    i.key,
                                                )
                                            }
                                        />
                                    ) : (
                                        <TextInput
                                            type={
                                                i.columnType === 'number'
                                                    ? 'number'
                                                    : 'text'
                                            }
                                            value={params.value}
                                            onChange={({ target }) =>
                                                params.setValue(target.value)
                                            }
                                            onBlur={({ target }) =>
                                                editColumn(
                                                    n,
                                                    target.value,
                                                    i.key,
                                                )
                                            }
                                        />
                                    )}
                                </div>
                            )
                        },
                    }
                })

                setDataStoreColumns([
                    {
                        headerName: 'N',
                        field: 'n',
                        checkboxSelection: true,
                        headerCheckboxSelection: true,
                        sortable: true,
                        maxWidth: 120,
                    },
                    ...cols,
                    {
                        field: 'Actions',
                        maxWidth: 120,
                        cellRenderer: (params) => (
                            <div className="icons">
                                <img
                                    src={deletIcon}
                                    onClick={() => {
                                        console.log(params.data.n)
                                        deleteSingleRow(params.data.n)
                                    }}
                                    style={{ cursor: 'pointer' }}
                                />
                                <img
                                    src={editGreen}
                                    style={{
                                        cursor: 'pointer',
                                        paddingLeft: '5px',
                                    }}
                                />
                            </div>
                        ),
                    },
                ])
            })
            .catch((e) => console.log(e))
    }, [render])

    const insertData = () => {
        InsertData(rows, id)
            .then(() => {
                toast.success('Data is successfully inserted')
                setRender(!render)
            })
            .catch((e) => toast.error(e))
    }
    const addRows = () => {
        const addedRow = {}
        for (let i of dataStoreColumns) {
            let value

            // if defaultValue exists (including false, 0, empty string)
            if (
                i.defaultValue !== undefined &&
                i.defaultValue !== null &&
                i.defaultValue !== ''
            ) {
                value = i.defaultValue
            } else if (i.types === 'boolean') {
                value = false // default for boolean
            } else {
                value = '' // default for others
            }

            addedRow[i.field] = value
        }
        console.log('addedRow', addedRow)
        setN(n + 1)
        setRows(normalizeColumns([...rows, addedRow]))
    }

    return (
        <>
            {showPopup && (
                <ModalEditObject
                    setShowPopup={setShowPopup}
                    editColumn={editColumn}
                    objectValue={objectValue}
                    setObjectValue={setObjectValue}
                    key1={key}
                    rowId={rowId}
                />
            )}

            <ListPage
                pg={25}
                insertData={insertData}
                insert={true}
                id={id}
                setShow={setShow}
                show={show}
                deleteSelectedRows={deleteSelectedRows}
                selctedRows={selctedRows}
                setSelectedRows={setSelectedRows}
                column={rows}
                title={`Data Store ${name}`}
                dataModelCall={getDataModel}
                tableColumns={dataStoreColumns}
                savedBtn="Save"
                editBtnStruc="Edit Structure"
                addRows={addRows}
                CreatePopupComponent={CreateNewDataStore}
            />
        </>
    )
}
